import { render, staticRenderFns } from "./RELChecklistsFuncionario.vue?vue&type=template&id=f65c5726&scoped=true&"
import script from "./RELChecklistsFuncionario.vue?vue&type=script&lang=js&"
export * from "./RELChecklistsFuncionario.vue?vue&type=script&lang=js&"
import style0 from "./RELChecklistsFuncionario.vue?vue&type=style&index=0&id=f65c5726&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65c5726",
  null
  
)

export default component.exports